import api from '~/services/api';
import PropTypes from 'prop-types';

const endPoint = 'batches';

// GET
export const getBatches = async (params) => {
  try {
    const { data } = await api.get(`/${endPoint}`, params);
    return data.data;
  } catch (error) {
    throw error;
  }
};

// CREATE
export const createBatches = async (values) => {
  try {
    const { data } = await api.post(`/${endPoint}`, values);
    return data.data;
  } catch (error) {
    throw error;
  }
};

// UPDATE
export const updateBatches = async (id, values) => {
  try {
    const { data } = await api.put(`/${endPoint}/${id}`, values);
    return data.data;
  } catch (error) {
    throw error;
  }
};

// DELETE
export const deleteBatches = async (id) => {
  try {
    const { data } = await api.delete(`/${endPoint}/${id}`);
    return data.data;
  } catch (error) {
    throw error;
  }
};

getBatches.propTypes = {
  values: PropTypes.object.isRequired,
};

createBatches.propTypes = {
  values: PropTypes.object.isRequired,
};

updateBatches.propTypes = {
  values: PropTypes.object.isRequired,
};

deleteBatches.propTypes = {
  id: PropTypes.string.isRequired,
};
